import {
	BatchSelectActionType,
	BatchSelectObjectType,
	TemplateObjectType,
} from 'webapp/enums/enums';

import type Template from 'webapp/models-custom/template';

import ModelManagerTemplatesService from 'webapp/services/model-manager/templates';

export default class ModelManagerBoardLoopTemplatesService extends ModelManagerTemplatesService {
	override get objectText(): string {
		return 'looped dashboard template';
	}

	override get objectType(): BatchSelectObjectType {
		return BatchSelectObjectType.BOARD_LOOP_TEMPLATE;
	}

	batchUpdateBoardLoopTags(selectedItems: Template[], tags: number[]): Promise<void> {
		const boardLoops = selectedItems.filter(
			(item) => item.objectType === TemplateObjectType.BOARD_LOOP,
		);
		const objectIds = boardLoops.map((item) => item.numericId!);

		return this.batchAction(BatchSelectActionType.UPDATE_TAGS, objectIds, tags);
	}

	batchDeleteBoardLoopTemplates(selectedItems: Template[]): Promise<void> {
		const boardLoops = selectedItems.filter(
			(item) => item.objectType === TemplateObjectType.BOARD_LOOP,
		);
		const objectIds = boardLoops.map((item) => item.numericId!);

		return this.batchAction(BatchSelectActionType.DELETE, objectIds);
	}
}

declare module '@ember/service' {
	interface Registry {
		'model-manager/board-loop-templates': ModelManagerBoardLoopTemplatesService;
	}
}
